module.exports = __webpack_public_path__ + "static/media/SM-MT1-TRIAL-if-correct.bec8735b.mp3";